import { render, staticRenderFns } from "./DAAlergyAlert.vue?vue&type=template&id=e1aed098&scoped=true"
import script from "./DAAlergyAlert.vue?vue&type=script&lang=js"
export * from "./DAAlergyAlert.vue?vue&type=script&lang=js"
import style0 from "./DAAlergyAlert.vue?vue&type=style&index=0&id=e1aed098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1aed098",
  null
  
)

export default component.exports